import { Action } from 'redux';
import { IApiErrorParams, IApiErrorWithRejectedRecords } from '@cbridge-packages/api-base';
import { NotificationAction } from '../notification.action';
import { formatApiErrorMessage } from './formatApiErrorMessage';

export function createApiErrorNotification(error: IApiErrorParams | IApiErrorWithRejectedRecords): Action {
  return NotificationAction.show({
    message: formatApiErrorMessage(error),
    severity: 'error',
  });
}
